import React, { Fragment, useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import PropTypes from 'prop-types';
import { HelpPopupInline } from '@bingads-webui-react/help-popup';
import { mergeStyles } from '@fluentui/react';

export const SortIcon = (props) => {
  const {
    isSorted, isSortedDescending, withCustomizedSortIcon,
  } = props;
  if (!isSorted) {
    return null;
  }
  const style = withCustomizedSortIcon ? {
    fontFamily: 'FabricMDL2Icons', fontSize: 14, fontStyle: 'normal', fontWeight: 'normal',
  }
    : {
      fontFamily: 'FabricMDL2Icons', fontSize: 12, fontStyle: 'normal', fontWeight: 'normal', paddingLeft: 4,
    };
  return (
    <i
      data-icon-name={isSortedDescending ? 'SortDown' : 'SortUp'}
      aria-hidden="true"
      className={`sort-icon ${mergeStyles(style)}`}
    >
      {isSortedDescending ? '' : ''}
    </i>);
};

SortIcon.propTypes = {
  isSorted: PropTypes.bool,
  withCustomizedSortIcon: PropTypes.bool,
  isSortedDescending: PropTypes.bool,
};

SortIcon.defaultProps = {
  isSorted: undefined,
  withCustomizedSortIcon: false,
  isSortedDescending: undefined,
};

export const WithCustomizedSortIcon = (props) => {
  const { withCustomizedSortIcon } = props;
  return withCustomizedSortIcon ?
    (
      <Fragment>
        <SortIcon {...props} />
        {props.children}
      </Fragment >
    ) :
    (
      <Fragment>
        {props.children}
        <SortIcon {...props} />
      </Fragment>
    );
};


WithCustomizedSortIcon.propTypes = {
  withCustomizedSortIcon: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

WithCustomizedSortIcon.defaultProps = {
  withCustomizedSortIcon: false,
};

export const HelpIcon = (props) => {
  const { name, helpId } = props;
  const i18n = useContext(I18nContext);
  return (
    <span
      className={`wrapped-help-icon ${mergeStyles({
        lineHeight: '32px',
      })}`}
    >
      <HelpPopupInline
        ariaLabel={i18n.getString(_TL_('Learn more about {{name}}'), { name })}
        topic={helpId}
      />
    </span>
  );
};

HelpIcon.propTypes = {
  helpId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export const NameHelpId = (props) => {
  const {
    column,
  } = props;

  return (
    <>
      {column.name}
      {column.helpId && <HelpIcon name={column.name} helpId={column.helpId} />}
    </>
  );
};

NameHelpId.propTypes = {
  column: PropTypes.shape({
    name: PropTypes.string,
    helpId: PropTypes.string,
  }).isRequired,
};

export const CommonColumn = (props) => {
  const {
    withCustomizedSortIcon, alignWithCampaignUI, column,
  } = props;

  return (
    <span
      className={`column-name ${mergeStyles(alignWithCampaignUI ? {
        display: 'inline-flex',
        alignItems: 'center',
        height: '42px',
        lineHeight: '32px',
      } : {})}`}
    >
      {withCustomizedSortIcon && <SortIcon isSorted={column.isSorted} isSortedDescending={column.isSortedDescending} withCustomizedSortIcon={withCustomizedSortIcon} />}
      <NameHelpId column={column} />
    </span>
  );
};

CommonColumn.propTypes = {
  withCustomizedSortIcon: PropTypes.bool,
  alignWithCampaignUI: PropTypes.bool,
  column: PropTypes.shape({
    name: PropTypes.string,
    helpId: PropTypes.string,
    isSorted: PropTypes.bool,
    isSortedDescending: PropTypes.bool,
  }).isRequired,
};

CommonColumn.defaultProps = {
  withCustomizedSortIcon: false,
  alignWithCampaignUI: false,
};
